module.exports = __webpack_public_path__ + "img/constants-generator.e2942bcf.svg";